import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VizsgaFeladatEditDto extends IdentifiableDto {
	/**
	 * @module VizsgaFeladatEditDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.kerdesLeiras = null;
		/** @type {string} */
		this.kod = null;
		/** @type {number} */
		this.kerdesSorszam = null;
		/** @type {number} */
		this.kerdesAlsorszam = null;
		/** @type {number} */
		this.kerdesSubsorszam = null;
		/** @type {number} */
		this.torolt = null;
	}

	/**
	 * @typedef {Object} _VizsgaFeladatEditDtoProps
	 * @property {string} kerdesLeiras
	 * @property {string} kod
	 * @property {number} kerdesSorszam
	 * @property {number} kerdesAlsorszam
	 * @property {number} kerdesSubsorszam
	 * @property {number} torolt
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgaFeladatEditDtoProps} VizsgaFeladatEditDtoProps
	 */
	/**
	 *
	 * @param {VizsgaFeladatEditDtoProps} props
	 * @returns {VizsgaFeladatEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.kerdesLeiras = props.kerdesLeiras;
		this.kod = props.kod;
		this.kerdesSorszam = props.kerdesSorszam;
		this.kerdesAlsorszam = props.kerdesAlsorszam;
		this.kerdesSubsorszam = props.kerdesSubsorszam;
		this.torolt = props.torolt;
		return this;
	}
}

export default VizsgaFeladatEditDto;
